import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TiThMenuOutline } from "react-icons/ti";
import { GiCrossMark } from "react-icons/gi";

export default function Navbar( { scrollToAbout , scrollToService , scrollToProject , scrollToContact } ) {
    const [isOpen, setIsOpen] = useState(false);
    const [rotating, setRotating] = useState(false);
    const [isTop, setIsTop] = useState(true);
    const [show, setShow] = useState(false)

    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setRotating(!rotating);
        setTimeout(() => {
            setRotating(false);
        }, 500);

    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsTop(scrollTop === 0);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const toggleMain = () => {
        setRotating(true);
        setShow(!show);
        setTimeout(() => {
            setRotating(false);
        }, 500); // This should match the duration of the rotate animation
    };

        const btnclick = () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

    return (
        <div className=' flex justify-center'>
            <nav className={`z-50 ${isTop ? 'bg-transparent border-[1px]' : 'backdrop-blur-xl'} shadow-lg border-2 border-white rounded-3xl fixed top-2 p-4 m-4 w-[95%] font-dongle text-2xl transition duration-500 ease-in-out`}>
                <div className="container mx-auto flex justify-between items-center">
                    <button className="text-white text-4xl font-semibold"
                    onClick={btnclick}>Portfolio</button>
                    <div className="relative">
                        <div className="flex items-center justify-between w-full">
                            <div className="overflow-hidden w-full">
                                <div className={`${show ? "hidden md:flex gap-4 ease-in duration-500" : 'flex gap-4 mt-[-100px] md:mt-[-100px] ease-in duration-700'}`}>
                                    <Link onClick={btnclick} className="text-white hover:text-white">Home</Link>
                                    <Link 
                                    onClick={scrollToAbout} className="text-white hover:text-white">About</Link>
                                    <Link onClick={ scrollToService } className="text-white hover:text-white">Services</Link>
                                    <Link onClick={ scrollToProject} className="text-white hover:text-white">Projects</Link>
                                    <Link onClick={scrollToContact} className="text-white hover:text-white">Contact</Link>
                                </div>
                            </div>
                            <div>
                                <div className="hidden md:flex ml-4 justify-end">
                                    {show ? (
                                        <button
                                            className={`text-white hover:text-white ${rotating ? 'animate-rotate' : ''}`}
                                            onClick={toggleMain}
                                        >
                                            <GiCrossMark />
                                        </button>
                                    ) : (
                                        <button
                                            className={`text-white hover:text-white ${rotating ? 'animate-rotate' : ''}`}
                                            onClick={toggleMain}
                                        >
                                            <TiThMenuOutline />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="md:hidden fixed right-6">
                        <button
                            className={`text-white hover:text-white ${rotating ? 'animate-rotate' : ''}`}
                            onClick={toggleMenu}
                        >
                            {isOpen ? <GiCrossMark /> : <TiThMenuOutline />}
                        </button>
                    </div>

                </div>
                {isOpen && 'ease-in delay-500' && (
                    <div className="md:hidden mt-2 space-y-2 bg-gray-800 rounded-xl">
                        <Link to="/" className="block text-gray-300 hover:text-white">Home</Link>
                        <Link to="/about" className="block text-gray-300 hover:text-white">About</Link>
                        <Link to="/services" className="block text-gray-300 hover:text-white">Services</Link>
                        <Link to="/projects" className="block text-gray-300 hover:text-white">Projects</Link>
                        <Link to="/contact" className="block text-gray-300 hover:text-white">Contact</Link>
                    </div>
                )}
            </nav>
        </div>
    );
}
